class MobileFilterDrawer extends HTMLElement {
  constructor() {
    super();
    this.isClosing = false;
  }

  connectedCallback() {
    this.filterToggleButton = document.querySelector('.mobile-filter-toggle');
    this.drawerElement = this.querySelector('.mobile-filter-drawer');
    this.closeButton = this.querySelector('.mobile-filter-drawer__close');
    this.overlay = this.querySelector('.mobile-filter-drawer__overlay');
    this.applyButton = this.querySelector('.mobile-filter-drawer__apply-button');

    if (!this.drawerElement || !this.filterToggleButton) return;
    
    this.filterToggleButton.addEventListener('click', () => this.openDrawer());
    this.closeButton?.addEventListener('click', () => this.closeDrawer());
    this.overlay?.addEventListener('click', () => this.closeDrawer());
    this.applyButton?.addEventListener('click', () => this.applyFilters());
    
    // Use a single keydown event listener to prevent multiple closures
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleKeyDown(e) {
    if (e.key === 'Escape' && this.drawerElement.classList.contains('is-open')) {
      this.closeDrawer();
    }
  }

  openDrawer() {
    this.drawerElement.classList.add('is-open');
    this.filterToggleButton.setAttribute('aria-expanded', 'true');
    this.drawerElement.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'visible';
    document.body.style.overflowY = 'auto';
  }

  closeDrawer() {
    // Prevent multiple close events from firing
    if (this.isClosing) return;
    
    this.isClosing = true;
    this.drawerElement.classList.remove('is-open');
    this.filterToggleButton.setAttribute('aria-expanded', 'false');
    this.drawerElement.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = 'visible';
    document.body.style.overflowY = 'auto';
    
    // Reset the closing state after animation completes
    setTimeout(() => {
      this.isClosing = false;
    }, 300);
  }

  applyFilters() {
    // Submit the filter form
    const filterForm = this.querySelector('#filter-form');
    if (filterForm) {
      filterForm.submit();
    }
    this.closeDrawer();
  }
}

customElements.define('mobile-filter-drawer', MobileFilterDrawer);
